import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Injectable({
  providedIn: 'root'
})
export class HtmlSanitizationService {
  constructor(
    private readonly domSanitizer: DomSanitizer
  ) {}

  sanitize(description: string): SafeHtml {
    const sanitizedHtml = DOMPurify.sanitize(description);
    return this.domSanitizer.bypassSecurityTrustHtml(sanitizedHtml)
  }
}
